export type SourceKind = 'route' | 'gcs' | 'external' | 'db' | 'static';

export interface SourceDefinition {
  id: string;
  kind: SourceKind;
  url?: string;
  refetchMiliseconds?: number;
  staleAfterMiliseconds?: number;
  preload?: 'fetch' | 'image';
}

export const SECOND = 1_000;
export const MINUTE = 60_000;
export const HOUR = 60 * MINUTE;
